import cn from "classnames";
import Styles from "./FinalText.module.scss";
import { Text } from "src/components/atoms/Text/Text";

export interface FinalTextProps {
  text: string;
  result: string;
}

export const FinalText = ({ text, result }: FinalTextProps) => {
  return (
    <Text className={cn(Styles.finalText, Styles[result])} weight={"xbold"}>
      {text}
    </Text>
  );
};
